import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'
import NewTag2 from '../petprofile/NewTag2.vue'
import ScannedPage from '../petprofile/ScannedPage.vue'
import ScannedProfile from '@/petprofile/ScannedProfile.vue'
import RedirectTree from '@/petprofile/RedirectTree.vue'
// PET PROFILE MENU
import ScannedHealth from '../petprofile/ScannedHealth.vue'
import NotFound from '@/petprofile/resource/NotFound.vue';
//Onboarding
import OnboardingMain from '../landing/onboarding/OnboardingMain.vue'
import OnTheGoCheckout from '../petprofile/OnTheGoCheckout.vue'
// LANDING;
//EXTRAS
import ResetPassword from '../ResetPassword.vue'

import { store } from '../_store/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'OnboardingMain',
    component: OnboardingMain,
    meta: { layout: "nolayout" },
  },
  {
    path: '/on-the-go-checkout',
    name: 'OnTheGoCheckout',
    component: OnTheGoCheckout,
    meta: { layout: "nolayout" },
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta: { layout: "nolayout" }
  },
  {
    path: '/tag/:id',
    name: 'NewTag2',
    component: NewTag2,
    meta: { layout: "nolayout" }
  },
  {
    path: '/u/:username',
    name: 'ScannedProfile',
    component: ScannedProfile,
  },
  {
    path: '/u/:username/pet/:pet_id',
    name: 'ScannedPage',
    component: ScannedPage,
    meta: { layout: "nolayout" }
  },
  {
    path: '/u/:username/pet/:pet_id/health',
    name: 'ScannedHealth',
    component: ScannedHealth,
    meta: { layout: "nolayout" }
  },
  {
    path: '/get-connected',
    name: 'RedirectTree',
    component: RedirectTree,
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPassword,
    meta: { layout: "nolayout" }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
})

const openRoutes = ['NotFound', 'NewTag2', 'ScannedProfile', 'ScannedPage', 'ActivateByLogin', 'OnboardingMain', 'Onboarding1', 'ResetPassword', 'ForgotPassword', 'OnboardingPresentation', 'ScannedHealth', 'RedirectTree', 'OnTheGoCheckout']//open for everyone
const redundantRoutes = ['ResetPassword', 'ForgotPassword']

router.beforeEach((to, from, next) => {
  if (openRoutes.includes(to.name)) {
    next()
  } else if (store.getters.isAuthenthicated) {
    if (redundantRoutes.includes(to.name)) {
      next({ name: 'PetProfile' })
    } else {
      next()
    }
  } else {
    next({ name: 'Gate' })
  }
})

export default router
